import { PropsWithChildren } from "react";
import classNames from "classnames/bind";

import styles from "./Result.module.scss";
import { Result } from "./Result";
import { Button, Header } from "@datagame/ui";
import { Cell } from "../Grid/Cell";
import { t } from "i18next";
import { GameVisuals } from "../../../gql/graphql";

const cx = classNames.bind(styles);

export interface ResultModalProps extends PropsWithChildren {
  isVisible: boolean;
  onFinish: () => void;
  solution: string;
  guesses: string[];
  tries: number;
  score: number;
  theme: GameVisuals;
}

export const ResultModal = (props: ResultModalProps) => {
  const { onFinish, isVisible, guesses, solution, tries, score, theme } = props;

  return (
    <div className={cx("portal", { visible: isVisible })}>
      <button disabled={!onFinish} className={styles.background} onClick={() => onFinish?.()} />
      <div className={cx("resultModal")}>
        <Header className={styles.roundTracker} variant="h5">
          <div className={styles.solution}>
            {solution.split("").map((letter, index) => (
              <Cell status="correct" letter={letter} key={index} theme={theme} />
            ))}
          </div>
        </Header>

        <Header className={styles.roundTracker} variant="h6">
          <div>Your score: {score}</div>
        </Header>

        <Result guesses={guesses} solution={solution} tries={tries} theme={theme} />

        <Button className={styles.finishButton} onClick={onFinish}>
          {t("common:wordle.finishButton")}
        </Button>
      </div>
    </div>
  );
};
